"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const TrimWhitespace_1 = require("@/client/directives/TrimWhitespace");
const App_1 = __importDefault(require("@/client/components/App"));
const PlayerInputFactory_vue_1 = __importDefault(require("@/client/components/PlayerInputFactory.vue"));
const PreferencesManager_1 = require("@/client/utils/PreferencesManager");
const i18n_plugin_1 = __importDefault(require("@/client/plugins/i18n.plugin"));
const oauth_1 = require("@/client/oauth");
async function bootstrap() {
    const lang = (0, PreferencesManager_1.getPreferences)().lang;
    if (lang !== 'en') {
        try {
            window._translations = await fetch(`assets/locales/${lang}.json`).then((res) => res.json());
        }
        catch (err) {
            console.warn(`Cannot load ${lang} translations. See network for details.`);
        }
    }
    const app = (0, vue_1.createApp)(App_1.default);
    app.use(i18n_plugin_1.default);
    app.component('player-input-factory', PlayerInputFactory_vue_1.default);
    app.directive('trim-whitespace', {
        mounted: TrimWhitespace_1.trimEmptyTextNodes,
        updated: TrimWhitespace_1.trimEmptyTextNodes,
    });
    if (window.isSecureContext && 'serviceWorker' in navigator) {
        window.addEventListener('load', function () {
            navigator.serviceWorker.register('sw.js').then(function (registration) {
                console.log('registered the service worker', registration);
            });
        });
    }
    app.mount('#app');
    window.onload = oauth_1.startOauth;
}
bootstrap();
